const fb = require('../firebaseConfig.js')

export default {
    async fetchPositions({commit}) {
        await fb.positionsCollection.orderBy('sequence', 'asc').onSnapshot(querySnapshot => {
            let positions = []
            querySnapshot.forEach(position => {
                positions.push(position.data())
            })
            commit('setPositions', positions)
        })
    },
    fetchCompanyData({commit}) {
        commit('setCompanyData', fb.companyData())
    }
}